import { MoneyBox } from '@apply/components';
import { usePropertyRentalCurrentDebt } from '../../../../queries/PropertyFields/RentalCoreFields';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { formatCurrencyOrUndefined } from '@apply/ui';

export interface CurrentDebtRentalProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const CurrentDebtRental: React.FC<CurrentDebtRentalProps> = ({ propertyGuid, required, isReview = false }) => {
    const label = 'Current debt on property (enter $0 if you owe no debt)';
    const [currentDebt, set_currentDebt] = usePropertyRentalCurrentDebt(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(currentDebt)}
                />
            ) : (
                <MoneyBox
                    value={currentDebt}
                    onChange={(value) => set_currentDebt(value)}
                    label={label}
                    required={required}
                />
            )}
        </>
    );
};
